export default "__VITE_PUBLIC_ASSET__e2dd070a__"